var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91953 5.47461C5.08203 5.47461 6.03828 4.55586 6.03828 3.41211C6.03828 2.26836 5.08203 1.34961 3.91953 1.34961C2.75703 1.34961 1.80078 2.26836 1.80078 3.41211C1.80078 4.55586 2.75703 5.47461 3.91953 5.47461Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62539 6.375C9.63789 6.375 10.4441 5.5875 10.4441 4.59375C10.4441 3.6 9.61914 2.8125 8.62539 2.8125C7.63164 2.8125 6.80664 3.6 6.80664 4.59375C6.80664 5.5875 7.63164 6.375 8.62539 6.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71914 6.56172H8.55039C7.98789 6.56172 7.44414 6.73047 6.97539 7.01172C6.46914 6.33672 5.66289 5.88672 4.76289 5.88672H3.09414C1.55664 5.90547 0.337891 7.12422 0.337891 8.64297V9.99297C0.337891 10.3492 0.619141 10.6305 0.975391 10.6305H11.0441C11.4004 10.6305 11.7004 10.3305 11.7004 9.97422V9.52422C11.6816 7.89297 10.3504 6.56172 8.71914 6.56172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d500df226a2981318ac4ef93a3eff801.svg";
export { ForwardRef as ReactComponent };